import { DrinkPrices } from "./drink.prices.model";
import { DocumentData } from "@angular/fire/firestore";

export class DrinkPricesBuilder {
  public _monday: number;
  public _tuesday: number;
  public _wednesday: number;
  public _thursday: number;
  public _friday: number;
  public _saturday: number;
  public _sunday: number;

  public get monday(): number {
    return this._monday;
  }

  public set monday(price: number) {
    this._monday = price;
  }

  public get tuesday(): number {
    return this._tuesday;
  }

  public set tuesday(price: number) {
    this._tuesday = price;
  }

  public get wednesday(): number {
    return this._wednesday;
  }

  public set wednesday(price: number) {
    this._wednesday = price;
  }

  public get thursday(): number {
    return this._thursday;
  }

  public set thursday(price: number) {
    this._thursday = price;
  }

  public get friday(): number {
    return this._friday;
  }

  public set friday(price: number) {
    this._friday = price;
  }

  public get saturday(): number {
    return this._saturday;
  }

  public set saturday(price: number) {
    this._saturday = price;
  }

  public get sunday(): number {
    return this._sunday;
  }

  public set sunday(price: number) {
    this._sunday = price;
  }

  public load(data: DocumentData): DrinkPricesBuilder {
    this._monday = data.monday ? data.monday / 100 : null;
    this._tuesday = data.tuesday ? data.tuesday / 100 : null;
    this._wednesday = data.wednesday ? data.wednesday / 100 : null;
    this._thursday = data.thursday ? data.thursday / 100 : null;
    this._friday = data.friday ? data.friday / 100 : null;
    this._saturday = data.saturday ? data.saturday / 100 : null;
    this._sunday = data.sunday ? data.sunday / 100 : null;
    return this;
  }

  public edit(data: DrinkPrices): DrinkPricesBuilder {
    this._monday = data.monday;
    this._tuesday = data.tuesday;
    this._wednesday = data.wednesday;
    this._thursday = data.thursday;
    this._friday = data.friday;
    this._saturday = data.saturday;
    this._sunday = data.sunday;
    return this;
  }

  public setAll(price: number): DrinkPricesBuilder {
    this._monday = price;
    this._tuesday = price;
    this._wednesday = price;
    this._thursday = price;
    this._friday = price;
    this._saturday = price;
    this._sunday = price;
    return this;
  }

  public toJSON = () => ({
    monday: this.monday ? this.monday * 100 : null,
    tuesday: this.tuesday ? this.tuesday * 100 : null,
    wednesday: this.wednesday ? this.wednesday * 100 : null,
    thursday: this.thursday ? this.thursday * 100 : null,
    friday: this.friday ? this.friday * 100 : null,
    saturday: this.saturday ? this.saturday * 100 : null,
    sunday: this.sunday ? this.sunday * 100 : null
  });

  public build(): DrinkPrices {
    return new DrinkPrices(this);
  }
}
